// Configuration partagée pour les composants admin
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
